import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Dropdown } from "react-bootstrap";
import { AnchorComponent } from "../../components/elements";
import { FloatCardComponent, AdminPagosGiraComponent } from "../../components/cards";
import PageLayout from "../../layouts/PageLayout";

export default function DetallePasajeroPage() {

    const { t } = useContext(TranslatorContext)

    const floats = [
        { "title": "total_orders", "digit": 5789, "icon": "shopping_cart", "variant": "sm purple" }, 
        { "title": "total_reviews", "digit": 2373, "icon": "hotel_class", "variant": "sm yellow" },
        { "title": "total_products", "digit": 7893, "icon": "shopping_bag", "variant": "sm green" }
    ]
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Detalle Pasajero</h3>
                            <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">Administración</Link></li>
                                <li className="mc-breadcrumb-item">Giras</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                <Col xl={5}>
                    <div className="mc-card">
                        <div className="mc-card-header">
                            <h4 className="mc-card-title">Mi Gira</h4>
                            <Dropdown bsPrefix="mc-dropdown">
                                <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
                                    <i className='material-icons'>more_horiz</i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end" className="mc-dropdown-paper">
                                    <button type='button' className='mc-dropdown-menu'><i className='material-icons'>edit</i><span>{t('edit')}</span></button>
                                    <button type='button' className='mc-dropdown-menu'><i className='material-icons'>delete</i><span>{t('delete')}</span></button>
                                    <button type='button' className='mc-dropdown-menu'><i className='material-icons'>download</i><span>{t('download')}</span></button>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="mc-user-group">
                            <div className="mc-user-profile">
                                <div className="mc-round-avatar md">
                                    <img src="images/logo.png" alt="avatar" />
                                </div>
                                <div className="mc-duel-text md">
                                    <h3 className="mc-duel-text-title">Colegio Aleman</h3>
                                    <p className="mc-duel-text-descrip"></p>
                                </div>
                            </div>
                            <div className="mb-4">
                                <h6 className="mc-divide-title mb-4">Información</h6>
                                <ul className="mc-user-metalist">
                                <li><i className="material-icons">map</i><span>Curso: 4to A</span></li>
                                    <li><i className="material-icons">map</i><span>Comuna: Temuco</span></li>
                                    <li><i className="material-icons">map</i><span>Región: Araucania</span></li>
                                    <li><i className="material-icons">map</i><span>Fecha Viaje: 12/12/2024</span></li>
                                    <li><i className="material-icons">map</i><span>Nombre Contacto: Ivan</span></li>
                                    <li><i className="material-icons">map</i><span>Cargo Contacto: Presidete</span></li>
                                    <li><i className="material-icons">map</i><span>Contacto: +91 987-654-3210</span></li>
                                    <li><i className="material-icons">map</i><span>Email contacto: examplehotash.com</span></li>
                                    <li><i className="material-icons">map</i><span>Nombre Social: No registrado</span></li>
                                </ul>
                            </div>
                            
                           
                        </div>
                    </div>
                </Col>
                <Col xl={7}>
                    <Row>
                        {floats.map((float, index) => (
                            <Col md={4} lg={4} key={ index }>
                                <FloatCardComponent 
                                    variant={ float.variant }
                                    digit={ float.digit }
                                    title={ float.title }
                                    icon={ float.icon }
                                />
                            </Col>
                        ))}
                        <Col xl={12}> 
                            <AdminPagosGiraComponent /> 
                        </Col>
                    </Row>
                </Col>
            </Row>
        </PageLayout>
    )
}